import type { EntryViewT } from "@/types/database/entries";
import useExtractObservation from "../../observations/hooks/useExtractObservation";
import useExtractTracker from "./useExtractTracker";

export function extractEntryById(
	entriesView: EntryViewT[],
	entryId: string,
): EntryViewT | undefined {
	return entriesView?.find((m) => m.entry_id === entryId);
}

const useTrackerExtractEntry = (
	diaryId: string,
	trackerId: string,
	entryId: string,
) => {
	const tracker = useExtractTracker(diaryId, trackerId);
	const entry = extractEntryById(tracker?.entries_view ?? [], entryId);

	return entry;
};

export const extractObservationEntry = (
	diaryId: string,
	observationId: string,
	entryId: string,
) => {
	const observation = useExtractObservation(diaryId, observationId);
	const entry = extractEntryById(observation?.entries_view ?? [], entryId);

	return entry;
};

export default useTrackerExtractEntry;
